export const lineChartOptions = () => {
  return {
    chart: {
      // height: '100%',
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ['#4318FF', '#6AD2FF'],
    stroke: {
      curve: 'smooth',
    },
    title: {
      text: 'Web & Desktop Users',
      align: 'left',
      style: {
        fontSize: '14px',
        fontWeight: '700',
        fontFamily: 'Poppins',
        color: '#2B3674',
      },
    },
    xaxis: {
      categories: ['1/1', '1/2', '1/3', '1/4', '1/5', '1/6', '1/7'],
    },
    yaxis: {
      forceNiceScale: true,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
      fontSize: '10px',
      fontFamily: 'Poppins',

      markers: {
        width: 8,
        height: 8,
        radius: 22,
        offsetX: -5,
      },

      itemMargin: {
        horizontal: 15,
        vertical: 0,
      },
    },
  };
};

export const stackedChartOptions = ({ xData }) => {
  return {
    chart: {
      height: '100%',
      stacked: true,
      stackType: 'normal',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: '22%',
        borderRadius: 5,
      },
    },
    colors: ['#4318FF', '#6AD2FF'],
    stroke: {
      curve: 'smooth',
    },
    title: {
      text: 'Apple & Google Users',
      align: 'left',
      style: {
        fontSize: '14px',
        fontWeight: '700',
        fontFamily: 'Poppins',
        color: '#2B3674',
      },
    },
    xaxis: {
      categories: xData,
    },
    yaxis: {
      forceNiceScale: true,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
      fontSize: '10px',
      fontFamily: 'Poppins',

      markers: {
        width: 8,
        height: 8,
        radius: 22,
        offsetX: -5,
      },

      itemMargin: {
        horizontal: 15,
        vertical: 0,
      },
    },

    dataLabels: {
      enabled: false,
    },
  };
};

export const barChartOptions = ({ xData }) => {
  return {
    chart: {
      height: '100%',
      stacked: false,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: '35%',
        borderRadius: 0,
      },
    },
    colors: ['#A9EFFE', '#EA64D3'],
    stroke: {
      curve: 'smooth',
    },
    title: {
      text: 'Company',
      align: 'left',
      style: {
        fontSize: '14px',
        fontWeight: '700',
        fontFamily: 'Poppins',
        color: '#2B3674',
      },
    },
    xaxis: {
      categories: xData,
    },
    yaxis: {
      forceNiceScale: true,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
      fontSize: '10px',
      fontFamily: 'Poppins',

      markers: {
        width: 8,
        height: 8,
        radius: 22,
        offsetX: -5,
      },

      itemMargin: {
        horizontal: 15,
        vertical: 0,
      },
    },

    dataLabels: {
      enabled: false,
    },
  };
};
